export default "__VITE_ASSET__CO3_hftx__"